import React from 'react';
import { Calendar, Shield, User } from 'lucide-react';

const BulletinFooter = ({ bulletin }) => {
  const formatDate = (dateString) => {
    if (!dateString) return new Date().toLocaleDateString('fr-FR');
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="bulletin-footer">
      {/* Zone des signatures */}
      <div className="signatures bg-white p-6 border-t border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Signature du Directeur des Études */}
          <div className="signature-section">
            <div className="text-center">
              <div className="flex items-center justify-center mb-4">
                <User className="h-5 w-5 text-[#202654] mr-2" />
                <h4 className="text-lg font-semibold text-gray-900">
                  Le Directeur des Études
                </h4>
              </div>
              
              <div className="signature-area bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 mb-4">
                <div className="text-center">
                  <Shield className="h-12 w-12 text-gray-400 mx-auto mb-2" />
                  <p className="text-sm text-gray-500">
                    Signature et cachet
                  </p>
                </div>
              </div>
              
              <div className="border-t border-gray-300 pt-2">
                <p className="text-sm font-medium text-gray-700">
                  Nom et signature
                </p>
              </div>
            </div>
          </div>

          {/* Signature du Directeur Général */}
          <div className="signature-section">
            <div className="text-center">
              <div className="flex items-center justify-center mb-4">
                <Shield className="h-5 w-5 text-[#202654] mr-2" />
                <h4 className="text-lg font-semibold text-gray-900">
                  Le Directeur Général
                </h4>
              </div>
              
              <div className="signature-area bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 mb-4">
                <div className="text-center">
                  <Shield className="h-12 w-12 text-gray-400 mx-auto mb-2" />
                  <p className="text-sm text-gray-500">
                    Signature et cachet
                  </p>
                </div>
              </div>
              
              <div className="border-t border-gray-300 pt-2">
                <p className="text-sm font-medium text-gray-700">
                  Nom et signature
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Informations de génération */}
      <div className="bg-gray-50 border-t border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center text-sm text-gray-600">
            <Calendar className="h-4 w-4 mr-2" />
            <span>
              Document généré le {formatDate(bulletin?.date_generation)}
            </span>
          </div>
          
          <div className="text-sm text-gray-600">
            <span>Bulletin #{bulletin?.id || 'N/A'}</span>
          </div>
        </div>
      </div>

      {/* Note de bas de page */}
      <div className="bg-[#202654] text-white p-4">
        <div className="text-center">
          <p className="text-sm">
            <strong>NB :</strong> Conserver précieusement ce bulletin. Aucun double ne sera établi.
          </p>
          <div className="flex items-center justify-center mt-2 text-xs text-blue-200">
            <Shield className="h-3 w-3 mr-1" />
            <span>Document officiel - Système de gestion scolaire</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulletinFooter;
